import React, { useContext, Suspense } from 'react';

import { EntityContext } from 'context/entityContext';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import BrowseEntitiesSkeleton from 'components/data-containers/BrowseEntities/SkeletonLoader';

const BrowseEntity = React.lazy(() =>
  import('components/data-containers/BrowseEntities/BrowseEntity')
);

const Physical: React.FC = () => {
  const ctx = useContext(EntityContext);

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      {ctx.compareMode && (
        <>
          <Layout.MaxWidth>
            <Message>
              Shipped Units data is not available for tracks. Select a different
              topic to compare data.
            </Message>
          </Layout.MaxWidth>
        </>
      )}

      {!ctx.compareMode && (
        <>
          <Suspense
            fallback={
              <BrowseEntitiesSkeleton
                title="Browse Releases"
                browseEntityType="release"
                enableSearch
              />
            }
          >
            <BrowseEntity
              {...ctx}
              id="browse-releases"
              browseEntityType="release"
            />
          </Suspense>

          <Layout.MaxWidth>
            <Message>
              Shipped Units data is not available for tracks. Select a release
              to see related Shipped Units.
            </Message>
          </Layout.MaxWidth>
        </>
      )}
    </div>
  );
};

export default Physical;
